import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import { useState } from 'react'

import { useGetSbpPayment } from '../../services'
import { RefetchMessage, ToggleGroup, ViewPaymentSkeleton } from '../../components'

import { RefundOperationsTab } from './refund-operations-tab'
import { OperationInfoTab } from './operation-info-tab.tsx'

type ViewTabs = 'general' | 'refunds'
const VIEW_COMPONENTS: Record<ViewTabs, React.ElementType> = {
  general: OperationInfoTab,
  refunds: RefundOperationsTab,
}
export const SbpPaymentView = () => {
  const { id = '' } = useParams<{ id: string }>()
  const [activeTab, setActiveTab] = useState<ViewTabs>('general')

  const { data, isError, refetch, isRefetching, isLoading } = useGetSbpPayment(id)

  const handleActiveTab = (_: unknown, value: ViewTabs) => value && setActiveTab(value)

  if (!data?.data.operationId || isLoading) return <ViewPaymentSkeleton />

  if (isError) {
    return <RefetchMessage refetch={refetch} isRefetching={isRefetching} />
  }

  const ActiveComponent = VIEW_COMPONENTS[activeTab]
  return (
    <>
      <Box mb={7}>
        <ToggleGroup<ViewTabs>
          value={activeTab}
          items={[
            { title: 'Информация о платеже', value: 'general' },
            { title: 'История возвратов', value: 'refunds', disabled: !data.data.showReverseList },
          ]}
          onChange={handleActiveTab}
        />
      </Box>
      <ActiveComponent payment={data.data} />
    </>
  )
}
